/** @format */

import { Component, Input, OnInit } from '@angular/core';

import { UtilityService } from '@shared/data-access/services';

@Component({
	selector: 'shared-components-tool-tip',
	templateUrl: './tool-tip.component.html',
	styleUrl: './tool-tip.component.scss',
	standalone: false
})
export class ToolTipComponent implements OnInit {
	@Input() icon: string;
	@Input() hmfIcon: string;
	@Input() textHeader: string;
	@Input() textBody: string;

	public iconSVG = false;
	public randomUUIDForHeader: string = this.utilityService.generateUUID();
	public randomUUIDForBody: string = this.utilityService.generateUUID();

	constructor(private utilityService: UtilityService) {}

	/* istanbul ignore next */
	ngOnInit() {
		if (this.icon?.includes('.svg')) {
			this.iconSVG = true;
		}
	}
}
